module.exports = __webpack_public_path__ + "img/20210420_122108.b678b688.jpg";